import { Controller } from "@hotwired/stimulus"

// Requires typing the resource name to confirm deletion.
// Usage:
//   data-controller="confirm-delete"
//   data-confirm-delete-name-value="Guía trading XTB"
//   data-confirm-delete-resource-value="promoción"
export default class extends Controller {
  static values = { name: String, resource: { type: String, default: "elemento" } }

  initialize() {
    this.element.addEventListener("submit", event => {
      const expected = this.nameValue
      const typed = window.prompt(
        `Para borrar esta ${this.resourceValue}, escribe su nombre exacto:\n\n${expected}`
      )

      if (typed === null || typed.trim() !== expected.trim()) {
        event.preventDefault()
        if (typed !== null) {
          window.alert("El nombre no coincide. La operación ha sido cancelada.")
        }
      }
    })
  }
}
